import _ from 'lodash';

const validBooleans = ['true', 'yes'];

export const toBoolean = (value) => {
  if (typeof value === 'boolean') return value;

  if (typeof value === 'string') {
    return !!(validBooleans.includes(value));
  }
  return false;
};

// https://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
// TODO: https://www.npmjs.com/package/array-move ???
export function arrayMove(arr, oldIndex, newIndex) {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    // eslint-disable-next-line no-plusplus
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
}


export const getAgeAtSpecificDate = (dateOfBirth, specificDate) => {
  let age = specificDate.getFullYear() - dateOfBirth.getFullYear();
  if (specificDate.getMonth() < dateOfBirth.getMonth()) {
    age -= 1;
  } else if (specificDate.getMonth() === dateOfBirth.getMonth()
    && specificDate.getDate() < dateOfBirth.getDate()) {
    age -= 1;
  }

  return age;
};

export const getCurrentAge = dateOfBirth => getAgeAtSpecificDate(dateOfBirth, new Date());

export const getPreservationAge = (dateOfBirth) => {
  if (dateOfBirth < new Date('July 1, 1960')) {
    return 55;
  }
  if (dateOfBirth <= new Date('June 30, 1961') && dateOfBirth >= new Date('July 1, 1960')) {
    return 56;
  }
  if (dateOfBirth <= new Date('June 30, 1962') && dateOfBirth >= new Date('July 1, 1961')) {
    return 57;
  }
  if (dateOfBirth <= new Date('June 30, 1963') && dateOfBirth >= new Date('July 1, 1962')) {
    return 58;
  }
  if (dateOfBirth <= new Date('June 30, 1964') && dateOfBirth >= new Date('July 1, 1963')) {
    return 59;
  }
  return 60;
};

export const getFormattedMemberName = member => (`${member.title} ${member.firstName}${member.middleName && member.middleName !== '' ? ` ${member.middleName}` : ''} ${member.lastName}`);

export const isArrayEqual = (arr1, arr2) => _(arr1).xorWith(arr2, _.isEqual).isEmpty();

export default toBoolean;


export function getCurrentFY() {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  if (currentMonth > 6) {
    return currentYear + 1;
  }
  return currentYear;
}
